/**
 * Serialises an OAuth scopes array to a stable string for use as a
 * `useMemo`/`useCallback` dependency, avoiding the array-reference
 * instability that would otherwise force a recompute on every render.
 */
export function scopesCacheKey(scopes) {
  return scopes === null || scopes === void 0 ? void 0 : scopes.join('\0');
}